// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__10F0_","inputWrap":"CustomTip_inputWrap__2F2hi"};